import {container, TYPES} from "@/inversifyconfig/container.config.ts";
import {IHttpRequest} from "@/interfaces/IHttp.ts";

const http = container.get<IHttpRequest>(TYPES.IHttpRequest);

export async function getAssetById(assetId: number): Promise<any> {
    try {
        const res = await http.get(`asset/${assetId}`);

        if(res.data) {
            return Promise.resolve(res.data)
        }
    }
    catch {
        return Promise.reject(new Error(`Couldn't find an asset with identifier "${assetId}"`));
    }


}